import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CprService
{
    public cpr: {
        dob: string
        checkDigits: string
    };
    public tempCpr:string;

    private dobExemptionList: string[] = ['010160', '010164', '010165', '010166', '010169', '010170', '010180', '010182', '010184', '010185', '010186', '010187', '010188', '010189', '010190', '010192'];

    public separateCpr(cpr: string): { dob: string; checkDigits: string }
    {
        this.cpr.dob = cpr.slice(0, 6);
        this.cpr.checkDigits = cpr.slice(6);
        return this.cpr;
    }

    public mergeCpr(dob: string, checkDigits: string): string
    {
        return dob.concat(checkDigits);
    }

    public formatCpr(date: Date): string
    {
        const dob = date || new Date();
        const dd = dob.getDate();
        const mm = dob.getMonth() + 1;
        const yy = dob.getFullYear().toString();
        const cprDobDigits =
            (dd < 10 ? '0' + dd : dd).toString() +
            (mm < 10 ? '0' + mm : mm).toString() +
            yy.substring(yy.length - 2);

        return cprDobDigits;
    }

    public modulus11Valid(cpr: string): boolean
    {
        let mod11CheckList: number[] = null;
        let checkSum = 0;

        if (cpr.length === 9)
        {
            mod11CheckList = [3, 2, 7, 6, 5, 4, 3, 2, 1];
        }
        else if (cpr.length === 10)
        {
            mod11CheckList = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
        }
        else
        {
            return false;
        }

        for (let i = 0; i < cpr.length; i++)
        {
            checkSum = checkSum + (mod11CheckList[i] * parseInt(cpr[i], 10));
        }

        return checkSum % 11 === 0;
    }

    public valid(dob: string, checkDigits: string): boolean
    {
        return this.modulus11Valid(`${dob}${checkDigits}`) || this.modulusExempted(dob, checkDigits);
    }

    public modulusExempted(dob: string, checkDigits: string): boolean
    {
        const parsedCheckDigits = parseInt(checkDigits, 10);

        return this.dobExemptionList.some(d => d === dob)
            && checkDigits.length === 4
            && parsedCheckDigits > 0
            && parsedCheckDigits < 4000;
    }

    public getBirthDateByCpr(cpr: string): Date
    {
        const dayPart = parseInt(cpr.substring(0, 2), 10);
        const monthPart = parseInt(cpr.substring(2, 4), 10) - 1;
        const yearPart = parseInt(cpr.substring(4, 6), 10);
        let birthYear;
        const stripDash = cpr.replace('-', '');
        const centuryIndicator = parseInt(stripDash.substring(6, 7));
        switch (stripDash.length)
        {
            case 9:
                birthYear = this.birthYearFO(centuryIndicator, yearPart);
                break;
            case 10:
                birthYear = this.birthYearDK(centuryIndicator, yearPart);
                break;
        }
        const result = new Date(birthYear, monthPart, dayPart, 0, 0, 0);
        return result;
    }

    private birthYearDK(centuryIndicator: number, yearPart: number): number
    {
        let result = 0;
        switch (centuryIndicator)
        {
            case 0:
            case 1:
            case 2:
            case 3:
                result = 1900 + yearPart;
                break;
            case 4:
            case 9:
                if (yearPart <= 36)
                {
                    result = 2000 + yearPart;
                }
                else
                {
                    result = 1900 + yearPart;
                }
                break;
            case 5:
            case 6:
            case 7:
            case 8:
                if (yearPart <= 57)
                {
                    result = 2000 + yearPart;
                }
                else
                {
                    result = 1800 + yearPart;
                }
                break;
        }
        return result;
    }

    private birthYearFO(centuryIndicator: number, yearPart: number): number
    {
        let result: number;
        // https://fo.wikipedia.org/wiki/P-tal - Do your own translation :P
        switch (centuryIndicator < 5)
        {
            case true:
                result = 1900 + yearPart;
                break;
            case false:
                result = 2000 + yearPart;
                break;
        }
        return result;
    }
}
